import { LocalPagamentoDto } from '../shared/dtos/LocalPagamento.dto'; 
import api from './api'; 

class LocalPagamentoService {
  // Criar um novo local de pagamento
  async createLocalPagamento(data: LocalPagamentoDto): Promise<LocalPagamentoDto> {
    return api
      .post('/local-pagamento/create', data)
      .then((response) => {
        return Promise.resolve(response.data); 
      })
      .catch((error) => {
        console.error(
          'Erro ao criar local de pagamento:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error); 
      });
  }

  // Buscar todos os locais de pagamento
  async getAllLocaisPagamento(): Promise<LocalPagamentoDto[]> {
    return api
      .get('/local-pagamento/all-pagamentos')
      .then((response) => {
        return Promise.resolve(response.data); 
      })
      .catch((error) => {
        console.error(
          'Erro ao buscar locais de pagamento:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error); 
      });
  }

  async getAllLocaisPagamentoWithLayoutRemessaRetorno(): Promise<LocalPagamentoDto[]> {
    return api
      .get('/local-pagamento/all-pagamentos-with-layout')
      .then((response) => {
        return Promise.resolve(response.data); 
      })
      .catch((error) => {
        console.error(
          'Erro ao buscar locais de pagamento:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error); 
      });
  }
  // Atualizar um local de pagamento existente
  async updateLocalPagamento(id: number, data: LocalPagamentoDto): Promise<LocalPagamentoDto> {
    return api
      .patch(`/local-pagamento/${id}`, data)
      .then((response) => {
        return Promise.resolve(response.data); 
      })
      .catch((error) => {
        console.error(
          'Erro ao atualizar local de pagamento:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error); 
      });
  }

  // Deletar um local de pagamento pelo ID
  async deleteLocalPagamento(id: number): Promise<void> {
    return api
      .delete(`/local-pagamento/excluir/${id}`)
      .then((response) => {
        return Promise.resolve(response.data); 
      })
      .catch((error) => {
        console.error(
          'Erro ao deletar local de pagamento:',
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error); 
      });
  }
}

const localPagamentoService = new LocalPagamentoService();
export default localPagamentoService;
